import { cn } from "@/lib/cn";

/** Marca oficial DentalBook (livro + dente + estrelas) — Sidebar, loading, etc. */
export function DentalbookLogo({ className }: { className?: string }) {
  return (
    <img
      src="/dentalbook-logo.svg"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn("shrink-0 select-none", className)}
    />
  );
}
